import { createApp } from 'vue'
import App from './App.vue'
import http from './http.js'
import store from './store.js'
import router from './router.js'
import vant from 'vant'
import cookies from 'vue-cookies'
import share from '@/configs/share.js'
import client from '@/configs/client.js'
import instance from '@/request'
import 'vant/lib/index.css'
import 'amfe-flexible'
import './assets/styles/reset.css'
import './assets/styles/common.scss'
import './assets/styles/newYear.scss'

const app = createApp(App)
app.config.globalProperties.jumpLink = function (url) {
    if (url) {
        if (!url.indexOf('http')) {
            location.href = url;
        } else {
            router.push({
                path: url,
                query: {
                    close: '1'
                }
            });
        }
    }
}
app.config.globalProperties.login = function (back = '') {
    if (client.xinhua) {
        if (client.ios) {
            window.webkit.messageHandlers.goAppLogin.postMessage(null);
        } else {
            /* eslint-disable */
            xinhuanet.goAppLogin();
            /* eslint-enable */
        }
    } else {
        router.push('/login?back=' + back);
    }
}
app.config.globalProperties.initShare = function (data = {}) {
    data = Object.assign({}, share, data);
    data.link = data.link ? data.link : location.href;
    if (client.wechat) {
        window.wx.ready(() => {
            window.wx.updateAppMessageShareData({
                title: data.title,
                desc: data.description,
                link: data.link,
                imgUrl: data.image
            })
            window.wx.updateTimelineShareData({
                title: data.title,
                link: data.link,
                imgUrl: data.image
            })
        });
    } else if (client.xinhua) {
        let shareData = {
            title: data.title,
            desc: data.description,
            imgUrl: data.image,
            link: data.link
        }
        if (client.ios) {
            window.webkit.messageHandlers.updateAppShareData.postMessage(shareData);
        } else {
            /* eslint-disable */
            xinhuanet.updateAppShareData(JSON.stringify(shareData));
            /* eslint-enable */
        }
    }
}
app.config.globalProperties.arouseShare = function () {
    if (client.ios) {
        window.webkit.messageHandlers.share.postMessage(null);
    } else {
        /* eslint-disable */
        xinhuanet.share();
        /* eslint-enable */
    }
}
app.config.globalProperties.$http = http;
app.config.globalProperties.$cookie = cookies;
window.appContext = app;
app.use(router).use(store).use(vant).mount('#app')
app.config.globalProperties.initShare();
app.config.globalProperties.$httpClient = instance

const $newYearStyle = false // 新年样式，只改这里就可以
app.config.globalProperties.$newYearStyle = $newYearStyle
if ($newYearStyle) {
    document.getElementById('app').className = 'new_year'
}


import { Toast } from 'vant'

window.appDownloadVideoSuccessCallback = function () {
    Toast('保存成功');
}

export default app
